import { createSlice } from "@reduxjs/toolkit";
import {
  getOrdersTypes,
} from "../services/ordersTypesService";

let initialState = {
  isLoading: false,
  data: [],
  pages: 0,
  errors: null
};

const ordersTypesSlice = createSlice({
  name: "ordersTypes",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getOrdersTypes.pending, (state) => {
      state.isLoading = true;
      state.errors = null;
    })
    builder.addCase(getOrdersTypes.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.data = (payload[0] && JSON.parse(payload[0].jsonData)) || [];
      state.errors = null;
    })
    builder.addCase(getOrdersTypes.rejected, (state) => {
      state.isLoading = false;
      state.errors = [{ msg: "something went wrong!" }];
    })
  }
});

export default ordersTypesSlice.reducer;